var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"scrollable":"","id":_vm.modalId,"no-close-on-backdrop":"","title":_vm.modalTitle,"size":_vm.modalSize,"redLink":_vm.link},scopedSlots:_vm._u([{key:"modal-footer",fn:function(){return [_vm._v("   ")]},proxy:true}])},[_vm._t("default",function(){return [_c('p',{staticClass:"my-4"},[_vm._v("Hello from modal!")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }